import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPrice } from './priceAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchPriceDataWithFilters = createAsyncThunk(
  'Price/fetchPriceDataWithFilters',
  async ({ filter = {}, options = {} }) => {    
    const response = await fetchPrice({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchPriceDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPriceDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchPriceDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectPriceData = (state) => state.price.data;
export const selectPriceStatus = (state) => state.price.status;
export const selectPriceError = (state) => state.price.error;

export default priceSlice.reducer;
